module.exports = __webpack_public_path__ + "static/media/luis.62c47d81.png";